import { render, staticRenderFns } from "./EndorsementGroups.vue?vue&type=template&id=1a847244"
import script from "./EndorsementGroups.vue?vue&type=script&lang=ts"
export * from "./EndorsementGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports